import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ValidationHandlerService, TranslatedToastrService, EditComponent, BaseComponent, LanguageService } from 'lib/Vestra.shared';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('actionsRef') actionsRef: TemplateRef<EditComponent>;

    public title: string;
    public isLargeScreen: boolean = false;


    constructor(
        protected override validationHandlerService: ValidationHandlerService,
        private translatedToastrService: TranslatedToastrService,
        private translateService: TranslateService,
        protected override modalService: BsModalService,
        protected override spinnerService: NgxSpinnerService,
        protected override languageService: LanguageService,
    ) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }
    private _activeTab: number = 1;
    get activeTab() {
        return this._activeTab;
    }
    set activeTab(value: number) {
        this._activeTab = value;
    }

    ngAfterViewInit(): void {}
    public ngOnInit() {
    }

    public navigateToTab(index: number): void {
        this.activeTab = index;
    }
    public onSwipe(event: any) {
        if (this.isLargeScreen) {
            return;
        }

        const currentIndex = this.activeTab;
        if (event.deltaX < 0 && currentIndex < 3) {
            this.activeTab++;
        } else if (event.deltaX > 0 && currentIndex > 1) {
            this.activeTab--;
        } else {
            return;
        }
    }
}
